import React from 'react';
import { Alert, Button } from 'antd';

interface InsufficientCreditsAlertProps {
  message: string;
  shortfallCredits?: number | null;
  description?: React.ReactNode;
  onTopUpCredits?: () => void;
  buttonLabel?: string;
  showIcon?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const toFiniteNumber = (value: number | null | undefined): number | null => {
  if (typeof value !== 'number') return null;
  if (!Number.isFinite(value)) return null;
  return value;
};

const InsufficientCreditsAlert: React.FC<InsufficientCreditsAlertProps> = ({
  message,
  shortfallCredits,
  description,
  onTopUpCredits,
  buttonLabel = 'Top Up Credits',
  showIcon = true,
  style,
  className,
}) => {
  const shortfallValue = toFiniteNumber(shortfallCredits);
  const shortfallText = shortfallValue && shortfallValue > 0
    ? `You need ${Math.ceil(shortfallValue).toLocaleString()} more credits.`
    : null;

  const resolvedDescription = shortfallText && description ? (
    <div>
      <div>{shortfallText}</div>
      <div>{description}</div>
    </div>
  ) : (
    shortfallText || description || undefined
  );

  return (
    <Alert
      className={['insufficient-credits-alert', className].filter(Boolean).join(' ')}
      type="error"
      message={message}
      description={resolvedDescription}
      showIcon={showIcon}
      action={
        onTopUpCredits ? (
          <Button size="small" type="primary" onClick={onTopUpCredits}>
            {buttonLabel}
          </Button>
        ) : undefined
      }
      style={style}
    />
  );
};

export default InsufficientCreditsAlert;
